import { render, staticRenderFns } from "./img-magnifier.vue?vue&type=template&id=551fa4d8"
import script from "./img-magnifier.vue?vue&type=script&lang=js"
export * from "./img-magnifier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports